<script>/* eslint-disable */</script>

<template>
  <input
    class="
      !border border-gray-100 outline-none text-md py-2 px-3 placeholder-gray-400 disabled:bg-gray-100
    "
    :required="required"
    :placeholder="placeholder"
    :type="type"
    :disabled="disabled"
    :min="min"
    :max="max"
    :step="step"
    :value="value"
    :id="id"
    @input="$emit('input', $event.target.value)"
    v-maska :data-maska="mask"
    @blur="$emit('blur', $event)"
  />
</template>

<script>
import { vMaska } from "maska"

export default {
  props: {
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    mask: String,
    min: String,
    max: String,
    step: Number,
    value: undefined,
    id: String,
  },
  directives: {
    maska: vMaska
  }
}
</script>
